import { defineStore } from 'pinia';

export type ToastType = {
	icon?: 'alert' | 'confirm' | string; // 아이콘 (alert, confirm, 아님 직접 넣어줘도 됨)
	content: string; // 보여줄 문구
	subContent?: string;
	showTime?: number; // 몇 밀리초동안 보일지
};

type StoreStateType = {
	toast: ToastType;
};
export const useToastStore = defineStore('toast', {
	state: (): StoreStateType => {
		return {
			toast: {} as ToastType,
		};
	},
	getters: {},
	actions: {
		openToast(payload: ToastType) {
			this.toast = payload;
		},
		closeToast() {
			this.toast = {} as ToastType;
		},
		closeAll() {
			this.$reset();
		},
	},
});
